export default {
  zh: {
    pendingNotice: '您提交的申请我们正在审核中，请您耐心等候，如有任何疑问请联系我们：',
    cancelledNotice: '您提交的申请未通过审核。如有任何疑问请联系我们：',
    completeNotice: '您已是联盟推广成员，无需再次申请。如有任何疑问请联系我们：',
    sure: '确认'
  },
  en: {
    pendingNotice: 'You application is under review, please be patient. If you have any questions, please feel free to contact us ',
    cancelledNotice: 'You application is unapproved. If you have any questions, please feel free to contact us ',
    completeNotice: 'You have already joined our affilaite program and don\'t need to apply again. If you have any questions, please feel free to contact us:',
    sure: 'Sure'
  }
}



// WEBPACK FOOTER //
// ./src/components/becomeAffiliate/statusModal/lang.js